import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Loader from 'react-loader';
import _ from 'lodash';
import { fetchProviderCareConversations, connectSocket, sendCareMessage, sendProviderConvMessages, activeChat, fetchCareMessages, fetchPatientCareConversationObj, resetChatWindow } from './actions';
import ChatWindow from './components/ChatWindow';
import './styles';
import ChatSidebar from './ChatSidebar';
import { getKeyName } from '../helpers/getKeyName';

class SnapcareChat extends Component {
  state = {
    activeSidebarPatientId: null,
  };
  componentDidMount() {
    // this.props.connectSocket();
    // this.props.allNotificationsSeen();
    this.props.fetchProviderCareConversations();
    if (this.props.match.params.id) {
      this.props.fetchPatientCareConversationObj(this.props.match.params.id);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.patientCareConversationObj !== nextProps.patientCareConversationObj && nextProps.patientCareConversationObj !== null) {
      if (this.props.match.params.id) {
        this.props.fetchCareMessages(nextProps.patientCareConversationObj.id);
        this.props.activeChat(nextProps.patientCareConversationObj.patientId, nextProps.patientCareConversationObj.id, nextProps.patientCareConversationObj.patientDetails);
        // document.getElementById(obj.id).scrollIntoView();
      }
    }
  }

  getActivePatientProfile = (patientObj) => {
    if (patientObj !== null) {
      return {
        teamName: getKeyName(patientObj, ['firstName', 'lastName']),
        imageUrl: patientObj.imageUrl,
        id: patientObj.id,
      };
    }
    return {
      teamName: '',
      imageUrl: '',
      id: '',
    };
  };

  getActiveProviderProfile = (providerObj) => {
    if (providerObj !== null) {
      return {
        teamName: getKeyName(providerObj, ['firstName', 'lastName']),
        imageUrl: providerObj.imageUrl,
      };
    }
    return {
      teamName: '',
      imageUrl: '',
    };
  };

  handleMessageSent = (message) => {
    const messageObj = Object.assign({}, message, {
      sentAt: moment.utc().format(),
      receiver: this.props.patientId,
      careConversation: this.props.careConversationId,
    });
    console.log(messageObj);
    this.props.sendCareMessage(messageObj);
  };

  handleProviderMessageSent = (message) => {
    const messageObj = Object.assign({}, message, {
      sentAt: moment.utc().format(),
      receiver: this.props.activeProviderId,
      receiverIdentity: this.props.activeProviderDetails.entityType,
      senderIdentity: 'Provider',
    });
    this.props.sendProviderConvMessages(messageObj);
  };

  componentWillUnmount() {
    this.props.resetChatWindow();
  }

  render() {
    return (
      <Container fluid>
        <Loader loaded={this.props.loaded} />
        <Row>
          <Col
            xs={'3'}
            style={{
              maxHeight: '85vh',
              backgroundColor: '#fff',
              paddingRight: 0,
              overflowY: 'scroll',
            }}
          >
            <ChatSidebar patientList={this.props.careConversations} activeSidebarPatientId={this.state.activeSidebarPatientId} />
          </Col>
          <Col xs={'9'}>
            {this.props.isProviderChatActive ? (
              <ChatWindow
                agentProfile={this.getActiveProviderProfile(this.props.activeProviderDetails)}
                messageList={this.props.providerConvMessages}
                onUserInputSubmit={this.handleProviderMessageSent}
              />
            ) : (
              <ChatWindow agentProfile={this.getActivePatientProfile(this.props.patientDetails)} messageList={this.props.careMessages} onUserInputSubmit={this.handleMessageSent} />
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

SnapcareChat.propTypes = {
  fetchProviderCareConversations: PropTypes.func,
  careConversations: PropTypes.array,
  loaded: PropTypes.bool,
  connectSocket: PropTypes.func,
  patientDetails: PropTypes.object,
  patientId: PropTypes.string,
  careConversationId: PropTypes.string,
  careMessages: PropTypes.array,
  sendCareMessage: PropTypes.func,
  isProviderChatActive: PropTypes.bool,
  activeProviderDetails: PropTypes.object,
  activeProviderId: PropTypes.string,
  sendProviderConvMessages: PropTypes.func,
  providerConvMessages: PropTypes.array,
  fetchCareMessages: PropTypes.func,
  activeChat: PropTypes.func,
  fetchPatientCareConversationObj: PropTypes.func,
  patientCareConversationObj: PropTypes.object,
  resetChatWindow: PropTypes.func,
  allNotificationsSeen: PropTypes.func,
};
SnapcareChat.defaultProps = {};

function mapStateToProps({ chat }) {
  return {
    careConversations: chat.patientSearchResults,
    loaded: chat.loaded,
    patientDetails: chat.activePatientDetails,
    patientId: chat.activePatientId,
    careConversationId: chat.activeCareConversationId,
    careMessages: chat.careMessages,
    activeProviderId: chat.activeProviderId,
    activeProviderDetails: chat.activeProviderDetails,
    isProviderChatActive: chat.isProviderChatActive,
    providerConvMessages: chat.providerConvMessages,
    patientCareConversationObj: chat.patientCareConversationObj,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchProviderCareConversations,
      connectSocket,
      sendCareMessage,
      sendProviderConvMessages,
      activeChat,
      fetchCareMessages,
      fetchPatientCareConversationObj,
      resetChatWindow,
      allNotificationsSeen,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SnapcareChat);
